export default __webpack_public_path__ + "static/media/thop-aparelho-estetico.619e7f7d.png";